import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d2ff2e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "performance-layout" }
const _hoisted_2 = { class: "flex align-items-center justify-content-between flex-wrap gap-3" }
const _hoisted_3 = { class: "flex flex-column gap-1" }
const _hoisted_4 = { class: "flex align-items-center gap-2 flex-wrap" }
const _hoisted_5 = {
  key: 0,
  class: "performance-empty"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-chart-line performance-empty-icon" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Select a billing period to view PPM results.", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "summary-grid mb-4" }
const _hoisted_10 = { class: "summary-card" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-label" }, "Period", -1))
const _hoisted_12 = { class: "summary-value" }
const _hoisted_13 = { class: "summary-card" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-label" }, "Minute samples", -1))
const _hoisted_15 = { class: "summary-value" }
const _hoisted_16 = { class: "summary-card" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-label" }, "Valid hours", -1))
const _hoisted_18 = { class: "summary-value text-green-500" }
const _hoisted_19 = { class: "summary-card" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-label" }, "Invalid hours", -1))
const _hoisted_21 = { class: "summary-value text-orange-500" }
const _hoisted_22 = { class: "summary-card" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-label" }, "Avg PR (valid hours)", -1))
const _hoisted_24 = { class: "summary-value" }
const _hoisted_25 = { class: "summary-card" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-label" }, "Avg APR (actual, temp-corrected)", -1))
const _hoisted_27 = { class: "summary-value" }
const _hoisted_28 = { class: "summary-card" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-label" }, "Avg PPR (projected)", -1))
const _hoisted_30 = { class: "summary-value" }
const _hoisted_31 = { class: "summary-card" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-label" }, "Avg PRD (PPR − APR)", -1))
const _hoisted_33 = { class: "text-sm text-color-secondary mb-3" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "i", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "act,i", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "i", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "i", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "i", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "i", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "i", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold" }, "Hourly performance ratio", -1))
const _hoisted_42 = { class: "flex align-items-center gap-2" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold" }, "Actual vs projected PR (temperature-corrected)", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-color-secondary mt-2 mb-0" }, " APR is the temperature-corrected actual PR; PPR is the contractual projected PR. Their gap (PRD = PPR − APR) drives the projected-energy deviation (EED). ", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "section-title" }, "Hourly results", -1))
const _hoisted_46 = { class: "flex align-items-center justify-content-between flex-wrap gap-2 mt-4 mb-2" }
const _hoisted_47 = { class: "section-title m-0" }
const _hoisted_48 = {
  key: 0,
  class: "text-sm font-normal text-color-secondary"
}
const _hoisted_49 = { class: "flex align-items-center gap-2" }
const _hoisted_50 = { class: "text-sm text-color-secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WTitle = _resolveComponent("WTitle")!
  const _component_WSubTitle = _resolveComponent("WSubTitle")!
  const _component_PDropdown = _resolveComponent("PDropdown")!
  const _component_PButton = _resolveComponent("PButton")!
  const _component_PTag = _resolveComponent("PTag")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_PCard = _resolveComponent("PCard")!
  const _component_PColumn = _resolveComponent("PColumn")!
  const _component_PDataTable = _resolveComponent("PDataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PCard, null, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_WTitle, { text: "Performance (PPM)" }),
            _createVNode(_component_WSubTitle, { text: "Plant performance ratio — minute samples and hourly averages" })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_PDropdown, {
              options: _ctx.periodOptions,
              optionLabel: "label",
              optionValue: "value",
              placeholder: "Select billing period",
              style: {"min-width":"12rem"},
              modelValue: _ctx.billingPeriodId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.billingPeriodId) = $event)),
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onPeriodChange()))
            }, null, 8, ["options", "modelValue"]),
            (_ctx.canRun)
              ? _withDirectives((_openBlock(), _createBlock(_component_PButton, {
                  key: 0,
                  disabled: !_ctx.billingPeriodId || _ctx.running,
                  loading: _ctx.running,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.runPpm())),
                  icon: "pi pi-play",
                  label: "Run PPM",
                  rounded: "",
                  size: "small",
                  severity: "success"
                }, null, 8, ["disabled", "loading"])), [
                  [
                    _directive_tooltip,
                    'Recompute performance ratio for this period',
                    void 0,
                    { left: true }
                  ]
                ])
              : _createCommentVNode("", true),
            _createVNode(_component_PButton, {
              disabled: !_ctx.billingPeriodId || _ctx.loading,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.refresh())),
              icon: "pi pi-refresh",
              label: "Refresh",
              outlined: "",
              rounded: "",
              size: "small"
            }, null, 8, ["disabled"])
          ])
        ])
      ]),
      content: _withCtx(() => [
        (!_ctx.billingPeriodId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createTextVNode(_toDisplayString(_ctx.results?.period?.name || '—') + " ", 1),
                    (_ctx.results?.period)
                      ? (_openBlock(), _createBlock(_component_PTag, {
                          key: 0,
                          severity: _ctx.periodSeverity(_ctx.results.period.status),
                          class: "ml-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.results.period.status), 1)
                          ]),
                          _: 1
                        }, 8, ["severity"]))
                      : _createCommentVNode("", true),
                    (_ctx.results?.period?.is_trial)
                      ? (_openBlock(), _createBlock(_component_PTag, {
                          key: 1,
                          severity: "warning",
                          class: "ml-1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("trial")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.summary.sample_count), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.summary.valid_hours), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.summary.invalid_hours), 1)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.formatPr(_ctx.summary.avg_pr)), 1)
                ]),
                (_ctx.hasTcMetrics)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.formatPr(_ctx.summary.avg_apr)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.formatPr(_ctx.summary.avg_ppr)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _hoisted_32,
                        _createElementVNode("div", {
                          class: _normalizeClass(["summary-value", _ctx.prdClass(_ctx.summary.avg_prd)])
                        }, _toDisplayString(_ctx.formatPr(_ctx.summary.avg_prd)), 3)
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", _hoisted_33, [
                _createTextVNode(" PR"),
                _hoisted_34,
                _createTextVNode(" = NEE"),
                _hoisted_35,
                _createTextVNode(" / (A"),
                _hoisted_36,
                _createTextVNode("·GPOA"),
                _hoisted_37,
                _createTextVNode("² + B"),
                _hoisted_38,
                _createTextVNode("·GPOA"),
                _hoisted_39,
                _createTextVNode(" + C"),
                _hoisted_40,
                _createTextVNode("). An hour is valid only with ≥10 samples and 100% good QF — no interpolation. Full export: "),
                _createElementVNode("a", {
                  class: "cursor-pointer",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.gotoReports()))
                }, "Reports → Plant Performance Model"),
                _createTextVNode(". ")
              ]),
              (_ctx.chartSeries[0].data.length)
                ? (_openBlock(), _createBlock(_component_PCard, {
                    key: 0,
                    class: "mb-4"
                  }, {
                    title: _withCtx(() => [
                      _hoisted_41
                    ]),
                    content: _withCtx(() => [
                      _createVNode(_component_apexchart, {
                        type: "line",
                        height: "280",
                        options: _ctx.chartOptions,
                        series: _ctx.chartSeries
                      }, null, 8, ["options", "series"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.hasTcMetrics && _ctx.tcChartSeries[0].data.length)
                ? (_openBlock(), _createBlock(_component_PCard, {
                    key: 1,
                    class: "mb-4"
                  }, {
                    title: _withCtx(() => [
                      _createElementVNode("div", _hoisted_42, [
                        _hoisted_43,
                        _createVNode(_component_PTag, { severity: "info" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Schedule 17 §3.12")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    content: _withCtx(() => [
                      _createVNode(_component_apexchart, {
                        type: "line",
                        height: "280",
                        options: _ctx.tcChartOptions,
                        series: _ctx.tcChartSeries
                      }, null, 8, ["options", "series"]),
                      _hoisted_44
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _hoisted_45,
              _createVNode(_component_PDataTable, {
                alwaysShowPaginator: false,
                loading: _ctx.loading,
                rowHover: true,
                rows: 24,
                showGridlines: true,
                stripedRows: true,
                value: _ctx.hourly,
                "data-key": "hour_start",
                paginator: "",
                selectionMode: "single",
                size: "small",
                selection: _ctx.selectedHour,
                "onUpdate:selection": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedHour) = $event)),
                onRowSelect: _ctx.onHourSelect
              }, {
                empty: _withCtx(() => [
                  _createTextVNode("No hourly PPM results yet. Run PPM for this period.")
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_PColumn, {
                    field: "hour_start",
                    header: "Hour start",
                    headerClass: "py-3",
                    sortable: ""
                  }),
                  _createVNode(_component_PColumn, {
                    field: "value_avg",
                    header: "PR avg",
                    headerClass: "py-3",
                    sortable: ""
                  }, {
                    body: _withCtx(({ data }) => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.formatPr(data.value_avg)), 1)
                    ]),
                    _: 1
                  }),
                  (_ctx.hasTcMetrics)
                    ? (_openBlock(), _createBlock(_component_PColumn, {
                        key: 0,
                        field: "apr",
                        header: "APR",
                        headerClass: "py-3"
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.formatPr(data.apr)), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.hasTcMetrics)
                    ? (_openBlock(), _createBlock(_component_PColumn, {
                        key: 1,
                        field: "ppr",
                        header: "PPR",
                        headerClass: "py-3"
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.formatPr(data.ppr)), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_PColumn, {
                    field: "is_valid",
                    header: "Valid",
                    headerClass: "py-3",
                    style: {"width":"100px"}
                  }, {
                    body: _withCtx(({ data }) => [
                      _createVNode(_component_PTag, {
                        severity: data.is_valid ? 'success' : 'danger'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(data.is_valid ? 'valid' : 'invalid'), 1)
                        ]),
                        _: 2
                      }, 1032, ["severity"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_PColumn, {
                    field: "invalid_reason",
                    header: "Reason",
                    headerClass: "py-3"
                  }, {
                    body: _withCtx(({ data }) => [
                      _createElementVNode("span", null, _toDisplayString(data.invalid_reason || '—'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_PColumn, {
                    field: "sample_count",
                    header: "Samples",
                    headerClass: "py-3",
                    sortable: ""
                  }),
                  _createVNode(_component_PColumn, {
                    field: "valid_sample_count",
                    header: "Valid samples",
                    headerClass: "py-3",
                    sortable: ""
                  })
                ]),
                _: 1
              }, 8, ["loading", "value", "selection", "onRowSelect"]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("h3", _hoisted_47, [
                  _createTextVNode(" Minute samples "),
                  (_ctx.sampleHourFilter)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_48, " · hour " + _toDisplayString(_ctx.sampleHourFilter), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_49, [
                  (_ctx.sampleHourFilter)
                    ? (_openBlock(), _createBlock(_component_PButton, {
                        key: 0,
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.clearHourFilter())),
                        label: "Show all hours",
                        link: "",
                        size: "small"
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.samples.total) + " total ", 1)
                ])
              ]),
              _createVNode(_component_PDataTable, {
                alwaysShowPaginator: true,
                lazy: true,
                loading: _ctx.samplesLoading,
                rowHover: true,
                rows: _ctx.sampleRowsPerPage,
                showGridlines: true,
                stripedRows: true,
                totalRecords: _ctx.samples.total,
                value: _ctx.samples.rows,
                "data-key": "ts_minute",
                paginator: "",
                size: "small",
                onPage: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onSamplesPage($event)))
              }, {
                empty: _withCtx(() => [
                  _createTextVNode("No minute samples for this filter.")
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_PColumn, {
                    field: "ts_minute",
                    header: "Minute",
                    headerClass: "py-3",
                    sortable: ""
                  }),
                  _createVNode(_component_PColumn, {
                    field: "hour_start",
                    header: "Hour",
                    headerClass: "py-3"
                  }),
                  _createVNode(_component_PColumn, {
                    field: "sample_value",
                    header: "PR sample",
                    headerClass: "py-3"
                  }, {
                    body: _withCtx(({ data }) => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.formatPr(data.sample_value)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_PColumn, {
                    field: "qf",
                    header: "QF",
                    headerClass: "py-3",
                    style: {"width":"80px"}
                  }, {
                    body: _withCtx(({ data }) => [
                      _createVNode(_component_PTag, {
                        severity: data.qf === 1 ? 'success' : 'danger'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(data.qf === 1 ? 'good' : 'bad'), 1)
                        ]),
                        _: 2
                      }, 1032, ["severity"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["loading", "rows", "totalRecords", "value"])
            ], 64))
      ]),
      _: 1
    })
  ]))
}